import React, { Fragment } from "react";

import styled from "@emotion/styled";

import { TypographyT35 } from "../Typography/index";

import { ReactComponent as ArrowOutline } from "Icons/ArrowOutline.svg";

export const AccordionT1 = styled("div")`
  border: 1px solid var(--color11);
  border-radius: 6px;
`;
export const AccordionHeaderT1 = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px;
  background-color: ${({ bgcolor }) =>
    !!bgcolor ? bgcolor : "var(--color19)"};
  border-radius: ${({ isOpenState }) =>
    !!isOpenState ? "2px 2px 0px 0px" : "2px"};
  cursor: pointer;
`;
export const AccordionHeaderLeftT1 = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
`;
export const AccordionHeaderRightT1 = styled("div")``;
export const AccordionSubHeaderContentT1 = styled("div")`
  background-color: var(--color20);
  border-radius: 6px;
`;

export const AccordionContentT1 = styled("div")`
  background-color: var(--color20);
  border-radius: 0px 0px 6px 6px;
  display: ${({ isOpenState }) => (!!isOpenState ? "block" : "none")};
  transition: display 0.8s ease;
`;

const StateIconWrapper = styled("div")`
  display: flex;
  align-items: center;
  transform: ${({ isOpenState }) =>
    !!isOpenState ? "rotate(90deg)" : "rotate(-90deg)"};
  transition: all 0.4s ease;
`;

export const AccordionHeaderSetupT1 = (props) => {
  const {
    icon,
    title,
    titleColor,
    accordionHeaderSetupBgcolor,
    isOpenState,
    action,
  } = props;
  return (
    <Fragment>
      <AccordionHeaderT1
        bgcolor={accordionHeaderSetupBgcolor}
        isOpenState={isOpenState}
        onClick={action}
      >
        <AccordionHeaderLeftT1>
          {icon}
          <TypographyT35 color={titleColor}>{title}</TypographyT35>
        </AccordionHeaderLeftT1>
        <AccordionHeaderRightT1>
          <StateIconWrapper isOpenState={isOpenState}>
            <ArrowOutline fill={titleColor} width={"24px"} />
          </StateIconWrapper>
        </AccordionHeaderRightT1>
      </AccordionHeaderT1>
    </Fragment>
  );
};
